import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Building2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import ItalyMap from "@/components/ItalyMap";
import ValutazioneOverview from "@/components/ValutazioneOverview";
import ImpegniOverview from "@/components/ImpegniOverview";
import { AgencyFunnelPanel } from "@/components/AgencyFunnelPanel";

export default function Operativita() {
  const { user } = useAuth();
  const canEditCard = user?.role === "admin" || user?.role === "back_office";
  const isAgency = user?.role === "agency";
  const [agencies, setAgencies] = useState([]);
  const [sel, setSel] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/agencies").then((r) => setAgencies(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const sortedAgencies = [...agencies].sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  return (
    <div className="space-y-6" data-testid="operativita-page">
      <div>
        <h1 className="font-heading text-3xl font-black tracking-tight">Valutazione {isAgency ? "agenzia" : "agenzie"}</h1>
        <p className="text-sm text-muted-foreground">Valutazione, impegni di chiusura e funnel commerciale.</p>
      </div>
      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
      ) : (
        <div className="space-y-6">
          <ValutazioneOverview sel={sel} setSel={setSel} agencies={sortedAgencies} />
          <ImpegniOverview sel={sel} setSel={setSel} agencies={sortedAgencies} />
          {canEditCard && <AgencyFunnelPanel />}
          <Card className="p-6" data-testid="operativita-map-card">
            <div className="mb-4 flex items-center gap-2">
              <Building2 className="h-4 w-4 text-primary" />
              <h2 className="font-heading text-lg font-bold tracking-tight">Distribuzione sul territorio</h2>
            </div>
            <ItalyMap />
          </Card>
        </div>
      )}
    </div>
  );
}
